import React from 'react'
const MyTeam = (props) => {
    return <h1>
        MY TEAM!
    </h1>
}
export default MyTeam